module.exports = __webpack_public_path__ + "static/media/algo2.49a32be6.png";